/**
 * Shared admin auth helpers for Ref Assist.
 *
 * Auth state is persisted in sessionStorage so that:
 *  - browser back/forward and page refresh preserve the session
 *  - closing the tab logs the user out
 *
 * An inactivity timeout (2 hours) auto-logs the user out as a safety belt.
 */

const STORAGE_KEY = 'refassist_admin_session';
const INACTIVITY_MS = 2 * 60 * 60 * 1000; // 2 hours

export const ADMIN_USERS = {
  'john@ref-assist.com': {
    password: 'refassist2024',
    role: 'superadmin',
    name: 'John',
  },
  'chris@ref-assist.com': {
    password: 'EppingMassiveOngar386@',
    role: 'admin',
    name: 'Chris',
  },
  'jaye@ref-assist.com': {
    password: 'EppingMassiveOngar386@',
    role: 'admin',
    name: 'Jaye',
  },
};

export function getAdminSession() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session || !session.email || !session.lastActivity) return null;
    if (Date.now() - session.lastActivity > INACTIVITY_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    // bump activity
    session.lastActivity = Date.now();
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    return session;
  } catch {
    return null;
  }
}

export function setAdminSession(user) {
  const session = {
    email: user.email,
    name: user.name,
    role: user.role,
    lastActivity: Date.now(),
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  return session;
}

export function clearAdminSession() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function authenticate(email, password) {
  const emailLower = (email || '').toLowerCase().trim();
  const adminUser = ADMIN_USERS[emailLower];
  if (adminUser && adminUser.password === password) {
    return { email: emailLower, role: adminUser.role, name: adminUser.name };
  }
  return null;
}
